import { JobsBoardSearchFiltersPayload } from '@hooks/jobsBoard/utils';
import { ApiNames, ApiProxy, ApiRequest, HttpMethod } from '@lib/api/apiProxy';

export class PublicApplicationCommandAPI {
  private static _apiProxy = ApiProxy.getInstance();
  private static _apiName = ApiNames.Applications;

  public static upsertJobsBoardDefaultFilters(
    jobsBoardDefaultFilters: JobsBoardSearchFiltersPayload,
    userId: number
  ): Promise<JobsBoardSearchFiltersPayload> {
    return this._apiProxy.execute(
      new ApiRequest(
        this._apiName,
        `/users/${userId}/jobsBoardDefaultFilters`,
        HttpMethod.POST,
        {
          default_filters_raw: JSON.stringify(jobsBoardDefaultFilters),
        }
      )
    );
  }
}
